import { render, staticRenderFns } from "./InformationNavigation.vue?vue&type=template&id=3c7b4280&scoped=true"
import script from "./InformationNavigation.vue?vue&type=script&lang=ts"
export * from "./InformationNavigation.vue?vue&type=script&lang=ts"
import style0 from "./InformationNavigation.vue?vue&type=style&index=0&id=3c7b4280&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7b4280",
  null
  
)

export default component.exports